import iview_zhCN from 'view-design/src/locale/lang/zh-CN'; // 简体中文
import iview_enUS from 'view-design/src/locale/lang/en-US'; // 英文


export default {
  'zh-CN': iview_zhCN,
  'en-US': iview_enUS,
}

